exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hospital-services-entry>span{color:white}.hospital-services-headline{border-bottom:solid 1px #ffffff59;padding-top:1rem}\n", ""]);

// exports
